import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './question-mentor-feedback.reducer';

export const QuestionMentorFeedbackDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const questionMentorFeedbackEntity = useAppSelector(state => state.questionMentorFeedback.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="questionMentorFeedbackDetailsHeading">
          <Translate contentKey="fivePlusApp.questionMentorFeedback.detail.title">QuestionMentorFeedback</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.id}</dd>
          <dt>
            <span id="meetingId">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.meetingId">Meeting Id</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.meetingId}</dd>
          <dt>
            <span id="menteeId">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.menteeId">Mentee Id</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.menteeId}</dd>
          <dt>
            <span id="mentorId">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.mentorId">Mentor Id</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.mentorId}</dd>
          <dt>
            <span id="feedBack">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.feedBack">Feed Back</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.feedBack}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {questionMentorFeedbackEntity.createdDate ? (
              <TextFormat value={questionMentorFeedbackEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updatedDate">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.updatedDate">Updated Date</Translate>
            </span>
          </dt>
          <dd>
            {questionMentorFeedbackEntity.updatedDate ? (
              <TextFormat value={questionMentorFeedbackEntity.updatedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="isShareFeedBack">
              <Translate contentKey="fivePlusApp.questionMentorFeedback.isShareFeedBack">Is Share Feed Back</Translate>
            </span>
          </dt>
          <dd>{questionMentorFeedbackEntity.isShareFeedBack ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.questionMentorFeedback.question">Question</Translate>
          </dt>
          <dd>{questionMentorFeedbackEntity.question ? questionMentorFeedbackEntity.question.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/question-mentor-feedback" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/question-mentor-feedback/${questionMentorFeedbackEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default QuestionMentorFeedbackDetail;
